var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FF9800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4266 9.77254C20.9776 8.39057 19.0224 8.39058 18.5734 9.77254L16.8303 15.1373C16.7634 15.3433 16.5714 15.4828 16.3548 15.4828H10.7139C9.26086 15.4828 8.6567 17.3422 9.83227 18.1963L14.3958 21.5119C14.571 21.6392 14.6444 21.8649 14.5774 22.0709L12.8343 27.4357C12.3853 28.8176 13.967 29.9668 15.1426 29.1127L19.7061 25.7971C19.8814 25.6698 20.1186 25.6698 20.2939 25.7971L24.8574 29.1127C26.033 29.9668 27.6147 28.8176 27.1657 27.4357L25.4226 22.0709C25.3556 21.8649 25.429 21.6392 25.6042 21.5119L30.1677 18.1963C31.3433 17.3422 30.7391 15.4828 29.2861 15.4828H23.6452C23.4286 15.4828 23.2366 15.3433 23.1697 15.1373L21.4266 9.77254Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.18f2f57fe72de16030387963f7138ef4.svg";
export { ForwardRef as ReactComponent };